(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-banner"]) return;
  try {
    
  var splide = new Splide( '.splide.blog-banner', {
    type: 'loop',
    autoplay: true,
    autoWidth: true,
    interval: 6000,
    pauseOnHover: false,
    focus: 'center',
    speed: 1000,
    perPage: 1,
    direction: 'ltr',
    arrowPath: 'M5.78756e-05 18.5153C-0.0042729 17.9494 0.231364 17.4081 0.64855 17.0257L18.6485 0.525668C19.4628 -0.220715 20.7279 -0.165711 21.4743 0.648528C22.2207 1.46276 22.1657 2.7279 21.3514 3.47428L4.9847 18.4771L21.3287 33.0052C22.1543 33.739 22.2287 35.0031 21.4948 35.8287C20.761 36.6543 19.4968 36.7286 18.6713 35.9948L0.671272 19.9948C0.248281 19.6188 0.00438877 19.0812 5.78756e-05 18.5153Z',
    focus: 'center',
    gap: '0',
    pagination: false,
    easing: 'cubic-bezier(0.7, 0.01, 0.27, 0.99)',
    drag: false,
    750: {
      drag: true,
    }
  } );
  splide.mount();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  var paragraphe = document.querySelector(".banner-collection .seo-text .metafield-rich_text_field");
  if (paragraphe) {
    paragraphe.parentElement.insertAdjacentHTML("afterend", '<span class="lire-plus">Lire la suite</span>');
    
    var lirePlus = document.querySelector(".lire-plus");
    lirePlus.addEventListener("click", function() {
      if (!this.classList.contains("active")) {
        document.head.insertAdjacentHTML('beforeend', '<style id="lire-plus">.shopify-section.banner-collection .content .seo-text .metafield-rich_text_field{    display: block;overflow: auto;}</style>');
        this.textContent = "Lire moins";
        this.classList.add("active");
      } else {
        var style = document.getElementById("lire-plus");
        if (style) {
          style.remove();
        }
        this.textContent = "Lire la suite";
        this.classList.remove("active");
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
